import PricePerTime from './PricePerTime.js';

export default class PriceChange {

    static fromData(data) {
        if (!data) {
            return;
        }

        let priceChange = new PriceChange();
        priceChange.start = data.start;
        priceChange.deleted = false;
        priceChange.pricePerTime = PricePerTime.fromData(data.pricePerTime);

        Object.seal(priceChange);
        return priceChange;
    }

    constructor(start, pricePerTime) {
        this.start = start;
        this.pricePerTime = pricePerTime;
        this.deleted = false;
    }

    clone() {
        let priceChange = new PriceChange();
        priceChange.start = this.start;
        priceChange.deleted = this.deleted;
        priceChange.pricePerTime = this.pricePerTime.clone();

        Object.seal(priceChange);
        return priceChange;
    }

    toData() {
        return {
            start: {
                day: parseInt(this.start.split('.')[0]),
                month: parseInt(this.start.split('.')[1]),
                year: parseInt(this.start.split('.')[2]),
            },
            pricePerTime: this.pricePerTime.toData(),
        }
    }

}
